import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-template7',
    templateUrl: './template7.component.html',
    styleUrls: ['./template7.component.scss']
})

export class Template7Component implements OnChanges {

    @Input() stackedBar;
    @Input() reportName;
    @Input() reportDate;
    @Input() dateFrom;
    @Input() dateTo;
    @Input() showChartFilters: boolean = false;
    @Input() selectedChartType: any = null;
    @Input() chartFilters: any[] = [];
    @Input() hideChart: boolean = false;

    @Output() changeChartFilter = new EventEmitter<any>();

    stackedOptions = {
        tooltips: {
            mode: 'index',
            intersect: false
        },
        responsive: true,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.stackedBar?.currentValue) {
            this.stackedBar = changes?.stackedBar?.currentValue;
            console.log("stackedBar",this.stackedBar);
        }

        if (changes?.selectedChartType?.currentValue){
            this.selectedChartType = changes?.selectedChartType?.currentValue;
            console.log("selectedChartType",this.selectedChartType);
        }
        console.log(this.hideChart);
    }

    onChangeChartFilter($event: any){
        this.changeChartFilter.emit(this.selectedChartType);
    }
}
